import { PaymentTermService } from '@cemex-core/cmx-api';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickResult, getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { OneClickPreviewField } from '../../util/constants/preview-fields';
import { createSelector } from '@ngrx/store';
import { getOneClickContractsAvailable } from '../../selectors/one-click-contract.selector';

const contractData = (index: number) =>
  createSelector(getOneClickSelectedOrder, getOneClickContractsAvailable(index), (selectedOrder, contracts) => {
    return { selectedOrder, contracts };
  });

export class OneClickPaymentProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[this.mapItem['index']]),
      map(item => {
        return `${item.paymentTerm.paymentTermDesc}`;
      }),
    );
  }
}
export class OneClickContractPaymentProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    return this.store.select(contractData(this.mapItem['index'])).pipe(
      filter(({ contracts }) => !!contracts),
      switchMap(({ selectedOrder, contracts }) => {
        const item = selectedOrder && selectedOrder.items && selectedOrder.items[this.mapItem['index']];
        const hasContract = !!item && !!item.agreementItem;
        const contractSelected = contracts.find(
          contract => contract.salesDocumentItemId === this.form.controls[OneClickPreviewField.Contract].value,
        );
        if (
          hasContract &&
          contractSelected &&
          contractSelected.paymentTerm &&
          contractSelected.paymentTerm.checkPaymentTerm
        ) {
          const paymentTermService = this.injector.get(PaymentTermService);
          return paymentTermService.getJobsitePaymentTermsByIdV2(contractSelected.paymentTerm.paymentTermId).pipe(
            map((payment: any) => {
              return payment.paymentTermType.paymentTermTypeDesc;
            }),
          );
        } else if (item) {
          return of(`${item.paymentTerm.paymentTermDesc}`);
        } else {
          return of (null);
        }
      }),
    );
  }
}

export class OneClickNoResultProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickResult).pipe(map(result => !result));
  }
}

export class OneClickHasResultProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickResult).pipe(map(result => !!result));
  }
}
